export const SECCION_TIPOS = [
  {
    value: 'calentamiento',
    label: 'Calentamiento',
    colorBg: 'bg-orange-100',
    colorText: 'text-orange-700',
    colorBorder: 'border-orange-300'
  },
  {
    value: 'hidratacion',
    label: 'Hidratacion',
    colorBg: 'bg-sky-100',
    colorText: 'text-sky-700',
    colorBorder: 'border-sky-300'
  },
  {
    value: 'tecnica',
    label: 'Tecnica',
    colorBg: 'bg-purple-100',
    colorText: 'text-purple-700',
    colorBorder: 'border-purple-300'
  },
  {
    value: 'movilidad',
    label: 'Movilidad y coordinacion',
    colorBg: 'bg-green-100',
    colorText: 'text-green-700',
    colorBorder: 'border-green-300'
  },
  {
    value: 'competitivo',
    label: 'Competitivo / Juego',
    colorBg: 'bg-red-100',
    colorText: 'text-red-700',
    colorBorder: 'border-red-300'
  },
  {
    value: 'cierre',
    label: 'Cierre / Estiramiento',
    colorBg: 'bg-gray-100',
    colorText: 'text-gray-700',
    colorBorder: 'border-gray-300'
  },
  {
    value: 'otro',
    label: 'Otro',
    colorBg: 'bg-slate-100',
    colorText: 'text-slate-700',
    colorBorder: 'border-slate-300'
  }
]

export const SECCION_TIPO_VALUES = SECCION_TIPOS.map((t) => t.value)

export const getSeccionTipoLabel = (value) => {
  const tipo = SECCION_TIPOS.find((t) => t.value === value)
  return tipo ? tipo.label : value
}

export const getSeccionTipoColor = (value) => {
  const tipo = SECCION_TIPOS.find((t) => t.value === value)
  if (!tipo) return ''
  return `${tipo.colorBg} ${tipo.colorText} ${tipo.colorBorder}`
}

export const isValidSeccionTipo = (value) => {
  return SECCION_TIPO_VALUES.includes(value)
}
